// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XFStQ","colMin":"styles_colMin__2QVEO"};